/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CreateWidgetAppearanceSettingsDto,
  CreateWorkspaceSettingsDto,
  EditorInfoDto,
  FileUpload,
  KickFireCanadianProvince,
  KickFireCompanyField,
  KickFireCountry,
  KickFireEmployees,
  KickFireRevenue,
  KickFireUsState,
  MapPlaybookIdPlaybook,
  MapPlaybookIdPlaybookDraft,
  MapString,
  Playbook,
  PlaybookDraft,
  PlaybookId,
  PlaybookInfoDto,
  PlaybookPriorities,
  PlaybookPublishDraftDto,
  PlaybookStateAction,
  PlaybookUpdateDraftDto,
  PrioritiesUpdateDto,
  UpdateWidgetAppearanceSettingsDto,
  UpdateWorkspaceSettingsDto,
  UploadResult,
  WidgetAppearanceSettings,
  WorkspaceSettings,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "chat-platform-builder";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Returns the current draft editor. If the timestamp of the last modification is older then TTL (default = 1 min) it returns empty body, otherwise it returns userId
   *
   * @tags playbook-draft-editorial
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidEditor
   * @summary Find current editor
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/drafts/{playbookId}/editor
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidEditor = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      EditorInfoDto,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts/${playbookId}/editor`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidEditor */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidEditorPathGetter = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts/${playbookId}/editor`);

  /**
   * @description Updates the lastModified field to prevent a lock from expiration or set a new lock.
   *
   * @tags playbook-draft-editorial
   * @name PutApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidEditor
   * @summary Claim ownership (lock others from editing)
   * @request PUT:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/drafts/{playbookId}/editor
   * @secure
   */
  putApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidEditor = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts/${playbookId}/editor`,
      method: "PUT",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidEditor */
  putApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidEditorPathGetter = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts/${playbookId}/editor`);

  /**
   * @description Handles an image/video upload.
   *
   * @tags media
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidFiles
   * @summary Upload media
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/drafts/{playbookId}/files
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidFiles = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
    data: FileUpload,
    params: RequestParams = {},
  ) =>
    this.request<
      UploadResult,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts/${playbookId}/files`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidFiles */
  postApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidFilesPathGetter = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts/${playbookId}/files`);

  /**
   * @description Find all drafts for a tenant
   *
   * @tags playbook-draft
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDrafts
   * @summary Find all
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/drafts
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDrafts = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      PlaybookDraft[],
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDrafts */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts`);

  /**
   * @description Creates an empty playbook draft
   *
   * @tags playbook-draft
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDrafts
   * @summary Create new playbook
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/drafts
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDrafts = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      PlaybookDraft,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDrafts */
  postApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts`);

  /**
   * @description Find a playbook by id and workspaceId
   *
   * @tags playbook-draft
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookid
   * @summary Find a playbook
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/drafts/{playbookId}
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookid = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      PlaybookDraft,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts/${playbookId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookid */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidPathGetter = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts/${playbookId}`);

  /**
   * @description Updates a draft if it exists
   *
   * @tags playbook-draft
   * @name PutApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookid
   * @summary Update a playbook
   * @request PUT:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/drafts/{playbookId}
   * @secure
   */
  putApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookid = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
    data: PlaybookUpdateDraftDto,
    params: RequestParams = {},
  ) =>
    this.request<
      PlaybookDraft,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts/${playbookId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookid */
  putApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidPathGetter = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts/${playbookId}`);

  /**
   * @description Find playbooks by PlaybookIds
   *
   * @tags playbook-draft
   * @name GetApiV1TenantTenantidPlaybooksDrafts
   * @summary Find playbooks by ids
   * @request GET:/v1/tenant/{tenantId}/playbooks/drafts
   * @secure
   */
  getApiV1TenantTenantidPlaybooksDrafts = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      id: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapPlaybookIdPlaybookDraft,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/playbooks/drafts`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidPlaybooksDrafts */
  getApiV1TenantTenantidPlaybooksDraftsPathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      id: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/playbooks/drafts`, query);

  /**
   * @description Playbook is created and published into pubsub as published
   *
   * @tags playbook-draft
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidPublish
   * @summary Publish a playbook
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/drafts/{playbookId}/publish
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidPublish = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
    data: PlaybookPublishDraftDto,
    params: RequestParams = {},
  ) =>
    this.request<
      Playbook,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts/${playbookId}/publish`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidPublish */
  postApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksDraftsPlaybookidPublishPathGetter = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/drafts/${playbookId}/publish`);

  /**
   * @description Finds all versions of all playbooks for a tenant
   *
   * @tags playbook-published
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublished
   * @summary Find all
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/published
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublished = (
    tenantId: string,
    workspaceId: string,
    query?: {
      latest?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      Playbook[],
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/published`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublished */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      latest?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/published`, query);

  /**
   * @description Finds the latest published playbook with a given PlaybookId, if one exists. Short version - no nodes
   *
   * @tags playbook-published
   * @name GetApiV1TenantTenantidPlaybooksPlaybookidInfo
   * @summary Find latest published playbook info
   * @request GET:/v1/tenant/{tenantId}/playbooks/{playbookId}/info
   * @secure
   */
  getApiV1TenantTenantidPlaybooksPlaybookidInfo = (tenantId: string, playbookId: string, params: RequestParams = {}) =>
    this.request<
      PlaybookInfoDto,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/playbooks/${playbookId}/info`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidPlaybooksPlaybookidInfo */
  getApiV1TenantTenantidPlaybooksPlaybookidInfoPathGetter = (tenantId: string, playbookId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/playbooks/${playbookId}/info`);

  /**
   * @description Finds all playbook versions
   *
   * @tags playbook-published
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookid
   * @summary Find all with ID
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/published/{playbookId}
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookid = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      Playbook[],
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/published/${playbookId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookid */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookidPathGetter = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/published/${playbookId}`);

  /**
   * @description Finds the latest published playbook with a given PlaybookId, if one exists
   *
   * @tags playbook-published
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookidLatest
   * @summary Find latest published playbook
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/published/{playbookId}/latest
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookidLatest = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      Playbook,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/published/${playbookId}/latest`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookidLatest */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookidLatestPathGetter = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/published/${playbookId}/latest`);

  /**
   * @description Finds the published playbook with a given PlaybookId and version
   *
   * @tags playbook-published
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookidVersionVersion
   * @summary Find published playbook version
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/published/{playbookId}/version/{version}
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookidVersionVersion = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
    version: number,
    params: RequestParams = {},
  ) =>
    this.request<
      Playbook,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/published/${playbookId}/version/${version}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookidVersionVersion */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookidVersionVersionPathGetter = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
    version: number,
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/published/${playbookId}/version/${version}`,
    );

  /**
   * @description Finds the latest published playbooks with given PlaybookIds. This endpoint is deprecated, use findLatestByIds2 instead.
   *
   * @tags playbook-published
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksLatest
   * @summary Find latest published playbooks
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/latest
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksLatest = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      id: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapPlaybookIdPlaybook,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/latest`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksLatest */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksLatestPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      id: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/latest`, query);

  /**
   * @description Finds the latest published playbooks with given PlaybookIds
   *
   * @tags playbook-published
   * @name GetApiV1TenantTenantidPlaybooksLatest
   * @summary Find batch of latest published playbooks
   * @request GET:/v1/tenant/{tenantId}/playbooks/latest
   * @secure
   */
  getApiV1TenantTenantidPlaybooksLatest = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      id: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapPlaybookIdPlaybook,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/playbooks/latest`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidPlaybooksLatest */
  getApiV1TenantTenantidPlaybooksLatestPathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      id: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/playbooks/latest`, query);

  /**
   * @description Activate or deactivate playbook
   *
   * @tags playbook-published
   * @name PutApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookidAction
   * @summary Update state of published playbook
   * @request PUT:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/published/{playbookId}/{action}
   * @secure
   */
  putApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookidAction = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
    action: PlaybookStateAction,
    params: RequestParams = {},
  ) =>
    this.request<
      Playbook,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/published/${playbookId}/${action}`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookidAction */
  putApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPublishedPlaybookidActionPathGetter = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
    action: PlaybookStateAction,
  ) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/published/${playbookId}/${action}`);

  /**
   * @description Runs a process that deletes playbook from everywhere, all the info related to playbook will be deleted as well
   *
   * @tags playbook-published
   * @name DeleteApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksCommonPlaybookid
   * @summary Delete playbook
   * @request DELETE:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/common/{playbookId}
   * @secure
   */
  deleteApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksCommonPlaybookid = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/common/${playbookId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksCommonPlaybookid */
  deleteApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksCommonPlaybookidPathGetter = (
    tenantId: string,
    workspaceId: string,
    playbookId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/common/${playbookId}`);

  /**
   * @description Finds a PlaybookPriorities data with given WorkspaceId for a tenant
   *
   * @tags playbook-priorities
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPriorities
   * @summary Find by WorkspaceId
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/priorities
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPriorities = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      PlaybookPriorities,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/priorities`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPriorities */
  getApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPrioritiesPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/priorities`);

  /**
   * @description Activate or deactivate playbook
   *
   * @tags playbook-priorities
   * @name PutApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPriorities
   * @summary Update playbook priorities
   * @request PUT:/v1/tenant/{tenantId}/workspaces/{workspaceId}/playbooks/priorities
   * @secure
   */
  putApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPriorities = (
    tenantId: string,
    workspaceId: string,
    data: PrioritiesUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      PlaybookPriorities,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/priorities`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPriorities */
  putApiV1TenantTenantidWorkspacesWorkspaceidPlaybooksPrioritiesPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/playbooks/priorities`);

  /**
   * No description
   *
   * @tags kickfire
   * @name GetApiV1TenantTenantidStaticKickfireRevenue
   * @summary KickFire Revenue, ranged
   * @request GET:/v1/tenant/{tenantId}/static/kickfire/revenue
   * @secure
   */
  getApiV1TenantTenantidStaticKickfireRevenue = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      KickFireRevenue[],
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/static/kickfire/revenue`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidStaticKickfireRevenue */
  getApiV1TenantTenantidStaticKickfireRevenuePathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/static/kickfire/revenue`);

  /**
   * No description
   *
   * @tags kickfire
   * @name GetApiV1TenantTenantidStaticKickfireEmployees
   * @summary KickFire Number of Employees, ranged
   * @request GET:/v1/tenant/{tenantId}/static/kickfire/employees
   * @secure
   */
  getApiV1TenantTenantidStaticKickfireEmployees = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      KickFireEmployees[],
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/static/kickfire/employees`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidStaticKickfireEmployees */
  getApiV1TenantTenantidStaticKickfireEmployeesPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/static/kickfire/employees`);

  /**
   * No description
   *
   * @tags kickfire
   * @name GetApiV1TenantTenantidStaticKickfireFields
   * @summary KickFire Company fields
   * @request GET:/v1/tenant/{tenantId}/static/kickfire/fields
   * @secure
   */
  getApiV1TenantTenantidStaticKickfireFields = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      KickFireCompanyField[],
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/static/kickfire/fields`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidStaticKickfireFields */
  getApiV1TenantTenantidStaticKickfireFieldsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/static/kickfire/fields`);

  /**
   * No description
   *
   * @tags kickfire
   * @name GetApiV1TenantTenantidStaticKickfireCountries
   * @summary KickFire countries
   * @request GET:/v1/tenant/{tenantId}/static/kickfire/countries
   * @secure
   */
  getApiV1TenantTenantidStaticKickfireCountries = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      KickFireCountry[],
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/static/kickfire/countries`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidStaticKickfireCountries */
  getApiV1TenantTenantidStaticKickfireCountriesPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/static/kickfire/countries`);

  /**
   * No description
   *
   * @tags kickfire
   * @name GetApiV1TenantTenantidStaticKickfireStatesUs
   * @summary KickFire US states
   * @request GET:/v1/tenant/{tenantId}/static/kickfire/states/us
   * @secure
   */
  getApiV1TenantTenantidStaticKickfireStatesUs = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      KickFireUsState[],
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/static/kickfire/states/us`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidStaticKickfireStatesUs */
  getApiV1TenantTenantidStaticKickfireStatesUsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/static/kickfire/states/us`);

  /**
   * No description
   *
   * @tags kickfire
   * @name GetApiV1TenantTenantidStaticKickfireStatesCa
   * @summary KickFire Canadian provinces
   * @request GET:/v1/tenant/{tenantId}/static/kickfire/states/ca
   * @secure
   */
  getApiV1TenantTenantidStaticKickfireStatesCa = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      KickFireCanadianProvince[],
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/static/kickfire/states/ca`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidStaticKickfireStatesCa */
  getApiV1TenantTenantidStaticKickfireStatesCaPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/static/kickfire/states/ca`);

  /**
   * @description Returns the latest widget appearance settings object if there is such, NotFound otherwise
   *
   * @tags widget-appearance
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidWidgetAppearance
   * @summary Get widget appearance settings for workspace
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/widget/appearance
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidWidgetAppearance = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      WidgetAppearanceSettings,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/widget/appearance`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidWidgetAppearance */
  getApiV1TenantTenantidWorkspacesWorkspaceidWidgetAppearancePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/widget/appearance`);

  /**
   * @description Updates widget appearance settings for workspace
   *
   * @tags widget-appearance
   * @name PutApiV1TenantTenantidWorkspacesWorkspaceidWidgetAppearance
   * @summary Update widget appearance settings for workspace
   * @request PUT:/v1/tenant/{tenantId}/workspaces/{workspaceId}/widget/appearance
   * @secure
   */
  putApiV1TenantTenantidWorkspacesWorkspaceidWidgetAppearance = (
    tenantId: string,
    workspaceId: string,
    data: UpdateWidgetAppearanceSettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<
      WidgetAppearanceSettings,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/widget/appearance`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidWorkspacesWorkspaceidWidgetAppearance */
  putApiV1TenantTenantidWorkspacesWorkspaceidWidgetAppearancePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/widget/appearance`);

  /**
   * @description Creates widget appearance settings for workspace
   *
   * @tags widget-appearance
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidWidgetAppearance
   * @summary Create widget appearance settings for workspace
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/widget/appearance
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidWidgetAppearance = (
    tenantId: string,
    workspaceId: string,
    data: CreateWidgetAppearanceSettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<
      WidgetAppearanceSettings,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/widget/appearance`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidWidgetAppearance */
  postApiV1TenantTenantidWorkspacesWorkspaceidWidgetAppearancePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/widget/appearance`);

  /**
   * @description Returns the latest workspace settings object if there is such, NotFound otherwise
   *
   * @tags workspace-settings
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidSettings
   * @summary Get workspace settings for workspace
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/settings
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidSettings = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      WorkspaceSettings,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidSettings */
  getApiV1TenantTenantidWorkspacesWorkspaceidSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/settings`);

  /**
   * @description Updates existing workspace settings for the specified workspace
   *
   * @tags workspace-settings
   * @name PutApiV1TenantTenantidWorkspacesWorkspaceidSettings
   * @summary Update workspace settings for workspace
   * @request PUT:/v1/tenant/{tenantId}/workspaces/{workspaceId}/settings
   * @secure
   */
  putApiV1TenantTenantidWorkspacesWorkspaceidSettings = (
    tenantId: string,
    workspaceId: string,
    data: UpdateWorkspaceSettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<
      WorkspaceSettings,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/settings`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidWorkspacesWorkspaceidSettings */
  putApiV1TenantTenantidWorkspacesWorkspaceidSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/settings`);

  /**
   * @description Creates new workspace settings for the specified workspace
   *
   * @tags workspace-settings
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidSettings
   * @summary Create workspace settings for workspace
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/settings
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidSettings = (
    tenantId: string,
    workspaceId: string,
    data: CreateWorkspaceSettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<
      WorkspaceSettings,
      | PlaybookId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/settings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidSettings */
  postApiV1TenantTenantidWorkspacesWorkspaceidSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/settings`);
}
